import { render, staticRenderFns } from "./DoctorListSelectAllAndNew.vue?vue&type=template&id=f2425f34&scoped=true"
import script from "./DoctorListSelectAllAndNew.vue?vue&type=script&lang=js"
export * from "./DoctorListSelectAllAndNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2425f34",
  null
  
)

export default component.exports